<script setup lang="ts">
import { translate } from '@/shared/i18n';
import { Btn } from '@/shared/ui';

const emit = defineEmits<{ (event: 'open'): void }>();
</script>

<template>
  <Btn
    class="px-4 py-2 text-sm font-medium"
    data-cookie-settings
    @click="emit('open')"
  >
    {{ translate('cookieConsent.settings') }}
  </Btn>
</template>
